import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="gantt-chart"
export default class extends Controller {
  static targets = ["groupRows"]

  connect() {
    this._tooltip = null
    this._hideTooltip = this._removeTooltip.bind(this)

    // Clean up tooltip on scroll (prevents stale tooltips)
    this._scrollContainer = this.element.querySelector(".overflow-auto")
    if (this._scrollContainer) {
      this._scrollContainer.addEventListener("scroll", this._hideTooltip)
    }
  }

  disconnect() {
    this._removeTooltip()
    if (this._scrollContainer) {
      this._scrollContainer.removeEventListener("scroll", this._hideTooltip)
    }
  }

  toggleGroup(event) {
    const groupId = event.currentTarget.dataset.groupId
    const rows = this.element.querySelectorAll(`[data-group-rows="${groupId}"]`)
    const chevron = event.currentTarget.querySelector("[data-chevron]")

    rows.forEach((row) => row.classList.toggle("hidden"))

    if (chevron) {
      chevron.classList.toggle("rotate-90")
    }
  }

  collapseAll() {
    this.groupRowsTargets.forEach((rows) => rows.classList.add("hidden"))
    this.element.querySelectorAll("[data-chevron]").forEach((chevron) => {
      chevron.classList.remove("rotate-90")
    })
  }

  expandAll() {
    this.groupRowsTargets.forEach((rows) => rows.classList.remove("hidden"))
    this.element.querySelectorAll("[data-chevron]").forEach((chevron) => {
      chevron.classList.add("rotate-90")
    })
  }

  showTooltip(event) {
    this._removeTooltip()

    const text = event.currentTarget.dataset.ganttTooltip
    if (!text) return

    const tooltip = document.createElement("div")
    tooltip.className =
      "fixed z-[9999] px-3 py-2 text-xs leading-relaxed rounded-lg shadow-lg pointer-events-none bg-base-300 text-base-content max-w-xs whitespace-pre-line"
    tooltip.textContent = text
    document.body.appendChild(tooltip)

    const rect = event.currentTarget.getBoundingClientRect()
    tooltip.style.left = `${rect.left}px`
    tooltip.style.top = `${rect.bottom + 6}px`

    // Keep tooltip within viewport
    requestAnimationFrame(() => {
      const tr = tooltip.getBoundingClientRect()
      if (tr.right > window.innerWidth) {
        tooltip.style.left = `${window.innerWidth - tr.width - 8}px`
      }
      if (tr.bottom > window.innerHeight) {
        tooltip.style.top = `${rect.top - tr.height - 6}px`
      }
    })

    this._tooltip = tooltip
  }

  hideTooltip() {
    this._removeTooltip()
  }

  openItemModal(event) {
    this._removeTooltip()

    const url = event.currentTarget.dataset.url
    const frameId = event.currentTarget.dataset.frameId

    if (url && frameId) {
      // Shared modal pattern
      const modal = this.element.querySelector("#shared_edit_modal")
      if (!modal) return
      const frame = modal.querySelector("turbo-frame")
      if (frame) {
        frame.id = frameId
        frame.innerHTML =
          '<div class="flex justify-center py-8"><span class="loading loading-spinner loading-lg"></span></div>'
        frame.src = url
      }
      modal.showModal()
      return
    }

    // Legacy fallback: per-item modal by item ID
    const itemId = event.currentTarget.dataset.itemId
    if (!itemId) return
    const modalId = `edit_field_cycle_line_item_modal_${itemId}`
    const modal = document.getElementById(modalId)
    if (!modal) return

    const frame = modal.querySelector("turbo-frame")
    const lazyUrl = modal.dataset?.lazyModalUrlValue
    if (frame && lazyUrl && !frame.src) {
      frame.src = lazyUrl
    }

    modal.showModal()
  }

  _removeTooltip() {
    if (this._tooltip) {
      this._tooltip.remove()
      this._tooltip = null
    }
  }
}
